var $122525af1cb737c7$exports = {};
$122525af1cb737c7$exports = {
    "close": `\u{5173}\u{95ED}`,
    "notifications": `\u{901A}\u{77E5}`
};


export {$122525af1cb737c7$exports as default};
//# sourceMappingURL=zh-CN.module.js.map
